export default `mutation SetAirWallexPaymentMethodOnCart(
      $cart_id: String!
      $code: String!
      $payment_intent_id: String!
      $client_secret: String!
      $payment_method: String!
    ) {
      setPaymentMethodOnCart(
        input: {
          cart_id: $cart_id
           payment_method: {
            code: $code
            airwallex_additional_data: {
              payment_intent_id: $payment_intent_id
              client_secret:  $client_secret
              payment_method: $payment_method
            }
          }
        }
      ) {
        cart {
          selected_payment_method {
            code
            title
          }
          prices {
            grand_total {
              value
              currency
            }
          }
        }
      }
  }
`;
